module.exports = __webpack_public_path__ + "img/google_play.be4f5d6e.png";